module.exports = __webpack_public_path__ + "static/vegan-cola_cans-3940d1ebe8ec92436f436f0d787e0577.jpg";